import { ERC20 } from 'src/common/types/models/Tokens'
import { arbitrumSepolia, polygon, ethereum, base } from 'thirdweb/chains'
import { ARBITRUM_SEPOLIA_KNOWN_TOKENS } from './arbitrum-sepolia-known-tokens'
import { POLYGON_KNOWN_TOKENS } from './polygon-known-tokens'
import { ETHEREUM_KNOWN_TOKENS } from './ethereum-known-tokens'
import { BASE_KNOWN_TOKENS } from './base-known-tokens'

export type KnownTokensValue = Record<string, ERC20>

export const KNOWN_TOKENS: Record<number, KnownTokensValue> = {
  [arbitrumSepolia.id]: ARBITRUM_SEPOLIA_KNOWN_TOKENS,
  [polygon.id]: POLYGON_KNOWN_TOKENS,
  [ethereum.id]: ETHEREUM_KNOWN_TOKENS,
  [base.id]: BASE_KNOWN_TOKENS,
}
